/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetBalanceDetailResponse } from './GetBalanceDetailResponse';
import {
    GetBalanceDetailResponseFromJSON,
    GetBalanceDetailResponseFromJSONTyped,
    GetBalanceDetailResponseToJSON,
    GetBalanceDetailResponseToJSONTyped,
} from './GetBalanceDetailResponse';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface PaginatedResultOfGetBalanceDetailResponse
 */
export interface PaginatedResultOfGetBalanceDetailResponse {
    /**
     * 
     * @type {Array<GetBalanceDetailResponse>}
     * @memberof PaginatedResultOfGetBalanceDetailResponse
     */
    items?: Array<GetBalanceDetailResponse>;
    /**
     * 
     * @type {any}
     * @memberof PaginatedResultOfGetBalanceDetailResponse
     */
    lastSelectedId?: any | null;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetBalanceDetailResponse
     */
    pageNumber?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetBalanceDetailResponse
     */
    pageSize?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetBalanceDetailResponse
     */
    totalCount?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {boolean}
     * @memberof PaginatedResultOfGetBalanceDetailResponse
     */
    hasNextPage?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PaginatedResultOfGetBalanceDetailResponse
     */
    hasPreviousPage?: boolean;
}

/**
 * Check if a given object implements the PaginatedResultOfGetBalanceDetailResponse interface.
 */
export function instanceOfPaginatedResultOfGetBalanceDetailResponse(value: object): value is PaginatedResultOfGetBalanceDetailResponse {
    return true;
}

export function PaginatedResultOfGetBalanceDetailResponseFromJSON(json: any): PaginatedResultOfGetBalanceDetailResponse {
    return PaginatedResultOfGetBalanceDetailResponseFromJSONTyped(json, false);
}

export function PaginatedResultOfGetBalanceDetailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedResultOfGetBalanceDetailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(GetBalanceDetailResponseFromJSON)),
        'lastSelectedId': json['lastSelectedId'] == null ? undefined : json['lastSelectedId'],
        'pageNumber': json['pageNumber'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['pageNumber']),
        'pageSize': json['pageSize'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['pageSize']),
        'totalCount': json['totalCount'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['totalCount']),
        'hasNextPage': json['hasNextPage'] == null ? undefined : json['hasNextPage'],
        'hasPreviousPage': json['hasPreviousPage'] == null ? undefined : json['hasPreviousPage'],
    };
}

export function PaginatedResultOfGetBalanceDetailResponseToJSON(json: any): PaginatedResultOfGetBalanceDetailResponse {
    return PaginatedResultOfGetBalanceDetailResponseToJSONTyped(json, false);
}

export function PaginatedResultOfGetBalanceDetailResponseToJSONTyped(value?: PaginatedResultOfGetBalanceDetailResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(GetBalanceDetailResponseToJSON)),
        'lastSelectedId': value['lastSelectedId'],
        'pageNumber': ApiUserTasksGetPageParameterToJSON(value['pageNumber']),
        'pageSize': ApiUserTasksGetPageParameterToJSON(value['pageSize']),
        'totalCount': ApiUserTasksGetPageParameterToJSON(value['totalCount']),
        'hasNextPage': value['hasNextPage'],
        'hasPreviousPage': value['hasPreviousPage'],
    };
}

